import Component from '@glimmer/component';
import FunctionalUtils from 'mewe/shared/functional-utils';
import { action } from '@ember/object';

export default class MwToaster extends Component {
  @action
  showToast(type) {
    switch (type) {
      case 'info':
        return FunctionalUtils.info(
          __(`Chat for group Universal has been turned on`)
        );
      case 'error':
        return FunctionalUtils.error(
          __(`Chat for group Universal has been turned on`)
        );
      case 'attention':
        return FunctionalUtils.attention(
          __(`Chat for group Universal has been turned on`)
        );
      case 'notice':
        return FunctionalUtils.notice(
          __(`Chat for group Universal has been turned on`)
        );
    }
  }
}
